// extracted by mini-css-extract-plugin
export var form = "getInTouch-module--form--f3f6a";
export var img = "getInTouch-module--img--c448e";
export var wrapper = "getInTouch-module--wrapper--69bc9";